/**
 * @desc 选中导出模板
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** 选中id */
  idList: string;
}

export function request(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.get({
    url: '/web/labour/checkExport',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<void>> {
  return defHttp.get({
    url: '/mock/web/labour/checkExport',

    params,
  });
}
